/* eslint-disable */
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import applicationStagesLabels from '../labels/applicationstages_en.json';
// import { getChallanDetails } from '../../../challanmanagement/actions/challanManagementAction';
// import AdvertisementDetails from './AdvertisementDetails';
// import { showApplicationStagesView,resetAdvertisementDetails, documentTemlateDownload } from '../actions/applicationStagesAction';
import { getAdvertisement, getPastAdvertisement, getYearList, resetAdvertisementDetails, showApplicationStagesView } from "../../../common/actions/commonActions";
import TablePagination from '../../../common/components/TablePagination';
import docLabels from '../../documentsverification/labels/documentlabel.json';
// import {generateMusterReportPdf } from "../components/CommonPdf";
import AdvertisementDetails from '../components/AdvertisementDetails';

const ActiveAdvertisement = (props) => {
  const [startYear, setStartYear] = useState((new Date()).getFullYear());
  const dispatch = useDispatch();

  //   const { activeAdvertisement,pastAdvertisement } = useSelector(
  //     (state) => state.challanManagementReducer,
  //     shallowEqual
  //   );
  const { showApplicationStagesDetails, yearList, activeAdvertisement, pastAdvertisement } = useSelector(
    (state) => state.applicationManagementReducer,
    shallowEqual
  );
  const [advtId, setAdvtId] = useState("");
  const advertisements = props.isPast === false ? activeAdvertisement : pastAdvertisement;

  const showApplicationstages = (ele) => {
    dispatch(resetAdvertisementDetails());
    // dispatch(getChallanDetails(ele.id))
    dispatch(showApplicationStagesView(true))
    setAdvtId(ele.id)
  }

  useEffect(() => {
    dispatch(getYearList())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (yearList && yearList.length > 0) {
      let year = yearList[0];
      setStartYear(year);
      dispatch(getAdvertisement(0, 10, year));
      dispatch(getPastAdvertisement(0, 10, year));
    }
    // eslint-disable-next-line
  }, [yearList])

  const searchAdvtData = () => {
    dispatch(getYearList())
    if (props.isPast === false) {
      dispatch(getAdvertisement(0, 10, startYear));
    }
    else {
      dispatch(getPastAdvertisement(0, 10, startYear));
    }
  };

  return showApplicationStagesDetails ? (
    <div>
      <AdvertisementDetails isPast={props.isPast} advtNo={advtId} />
    </div>
  ) :
    (
      <div className="border border-light text-center w-100 p-4" >
        <div className='form-group'>
          <div className='row'>
            <div className="col-md-4">
              <label className="font-weight-bold float-left">{docLabels.SELECT_YEAR}</label>
              <div className="input-group bg-color">
                <select
                  className="form-select bg-color"
                  name="selectedYear"
                  onChange={(e) => {
                    setStartYear(e.target.value)
                  }}
                >
                  {/* <option key={0} value="">
                            {commonLabels.SIGN_UP.SELECT}
                        </option> */}
                  {yearList &&
                    yearList.length > 0 &&
                    yearList
                      .map((element) => (
                        <option>{element}</option>
                      ))}
                </select>
              </div>
            </div>
            <div className='col-auto mt-4' >
              <button className='form-control  btn btn-primary custom_button  application_button_search' onClick={searchAdvtData} disabled={!startYear} ><i className="fa fa-search" type="button"></i></button>
            </div>
            {/* <div className='col-md-2 mt-4' >
              <button className='form-control btn-primary' onClick={handleClick} style={{ width:"105%",padding: "5px 15px 5px 5px" }}><i className="fa fa-search"></i></button>
            </div> */}
          </div>
        </div>
        <div className=''>
          <table className="table table-bordered">
          <thead className="table-primary">
              <tr>
                {applicationStagesLabels.adevertisementHeaderContent.map((ele, index) =>
                  <th scope="col" key={index} className='table-primary'>{ele}</th>
                )}
              </tr>
            </thead>
            <tbody style={{ fontSize: "12px" }}>
              {advertisements && advertisements.advertisements && advertisements.advertisements.length > 0 && advertisements.advertisements.map((ele, index) => {
                if (ele) {
                  return (
                    <tr key={index} >
                      <td className="word-break" >{ele.updatedAt ? dayjs(ele.updatedAt).format('DD/MM/YYYY h:mm A') : ""}</td>
                      <td className="word-break" >{ele.stage}</td>
                      <td className="word-break w10" >{ele.advertisementNo}{"/"}{ele.year}</td>
                      <td className="word-break" >{ele.name}</td>
                      <td className="word-break" >{ele.nameDvng} </td>
                      <td className="word-break" >{ele.updateBy} </td>
                      <td className="w-10 word-break text-center" >
                        <button type="button" style={{ fontSize: "11px", cursor: 'pointer' }} onClick={(e) => { showApplicationstages(ele) }} className="pull-right btn btn-outline-primary  custom_button  btn-sm">
                          {applicationStagesLabels.MANAGE}
                        </button>
                      </td>
                    </tr>
                  )
                }
              })
              }
            </tbody>
          </table>
        </div>
        {advertisements && advertisements.advertisements && advertisements.advertisements.length > 0 ?
          <TablePagination
            paginationFor={props.isPast === false ? "active_advt_list_challan_management" : "past_advt_list_challan_management"}
            totalCount={advertisements && advertisements.count}
            year={startYear}
          />
          : <p className='text-center'>{docLabels.NO_DATA}</p>}
      </div>
    )
}

export default ActiveAdvertisement;